// extracted by mini-css-extract-plugin
module.exports = {"page":"PlanningPage_page__17Z9y","lastActions":"PlanningPage_lastActions__1CcfA"};